var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34025 5.70097C3.30642 5.66801 3.16175 5.54355 3.04275 5.42763C2.29433 4.74797 1.06933 2.97495 0.695417 2.04696C0.635333 1.90603 0.508167 1.54972 0.5 1.35935C0.5 1.17694 0.542 1.00304 0.627167 0.837108C0.746167 0.630256 0.933417 0.46432 1.1545 0.373396C1.30792 0.314864 1.767 0.22394 1.77517 0.22394C2.27742 0.133016 3.0935 0.0830078 3.99533 0.0830078C4.85458 0.0830078 5.63742 0.133016 6.14725 0.20746C6.15542 0.215984 6.72592 0.306908 6.92133 0.406356C7.27833 0.588772 7.5 0.94508 7.5 1.32639V1.35935C7.49125 1.60769 7.26958 2.12993 7.26142 2.12993C6.88692 3.00791 5.722 4.74001 4.94792 5.43615C4.94792 5.43615 4.749 5.6322 4.62475 5.71745C4.44625 5.85042 4.22517 5.91634 4.00408 5.91634C3.75733 5.91634 3.5275 5.8419 3.34025 5.70097Z",
    fill: "#667883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleBold);
export default __webpack_public_path__ + "static/media/triangle_bold.1d35eb1d.svg";
export { ForwardRef as ReactComponent };